import { apiRequest } from ".";

export const getRecipesAPI = (data) => {
  return apiRequest({
    method: "get",
    url: `recipes`,
    queryParams: data,
  });
};
export const getRecipeDetailsAPI = (id) => {
  return apiRequest({
    method: "get",
    url: `recipes/${id}`,
  });
};
export const getRecipeImagesAPI = (id) => {
  return apiRequest({
    method: "get",
    url: `recipe-images/${id}`,
  });
};
export const addRecipeImagesAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `recipe-images/upload`,
    data: data,
  });
};
export const deleteRecipeImagesAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `recipe-images/${id}`,
  });
};
export const addRecipeAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `recipes`,
    data: data,
  });
};
export const editRecipeAPI = (id, data) => {
  return apiRequest({
    method: "put",
    url: `recipes/${id}`,
    data: data,
  });
};
export const deleteRecipeAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `recipes/${id}`,
    data: {},
  });
};
export const getIngredientsAPI = (id) => {
  return apiRequest({
    method: "get",
    url: `ingredients/${id}`,
  });
};
export const addIngredientsAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `ingredients`,
    data: data,
  });
};
export const deleteIngredientsAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `ingredients/${id}`,
    data: {},
  });
};
export const getCookingStepsAPI = (id) => {
  return apiRequest({
    method: "get",
    url: `cooking-steps/${id}`,
  });
};
export const addCookingStepsAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `cooking-steps`,
    data: data,
  });
};
export const updateCookingStepsAPI = (id, data) => {
  return apiRequest({
    method: "put",
    url: `cooking-steps/${id}`,
    data: data,
  });
};
export const deleteCookingStepsAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `cooking-steps/${id}`,
    data: {},
  });
};
export const getQuestionWithOptionsAPI = (id) => {
  return apiRequest({
    method: "get",
    url: `questions-with-options/${id}`,
  });
};
export const addQuestionAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `questions`,
    data: data,
  });
};
export const addQuestionWithOptionsAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `question-options`,
    data: data,
  });
};
export const deleteQuestionAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `questions/${id}`,
  });
};

export const deleteQuestionOptionAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `question-options/${id}`,
  });
};
export const getCombinationsAPI = (id) => {
  return apiRequest({
    method: "get",
    url: `combinations/${id}`,
  });
};
export const addCombinationsAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `combinations`,
    data: data,
  });
};
export const deleteCombinationsAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `recipe/${id}/combinations`,
  });
};
